"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _InternalLink = _interopRequireDefault(require("../../../atoms/InternalLink"));
var _OutboundLink = _interopRequireDefault(require("../../../atoms/OutboundLink"));
var _LinkContent = _interopRequireDefault(require("./LinkContent"));
require("../mobile.css");
var _default = function _default(_ref) {
  var slug = _ref.slug,
    pageTitle = _ref.pageTitle,
    internal = _ref.internal,
    linksAs = _ref.linksAs,
    onToggle = _ref.onToggle,
    centerMobileNavItems = _ref.centerMobileNavItems,
    linkComponent = _ref.linkComponent,
    backgroundColor = _ref.backgroundColor,
    internalLinkComponent = _ref.internalLinkComponent,
    className = _ref.className,
    disableToggle = _ref.disableToggle;
  var linkColor = backgroundColor === 'primary' || backgroundColor === 'secondary' ? 'white' : 'dark grey';
  var linkStyle = {
    color: linkColor,
    marginTop: '0.4em',
    display: 'block'
  };
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Container, (0, _extends2["default"])({}, !disableToggle ? {
    onClick: function onClick() {
      return onToggle();
    }
  } : {}, {
    className: "mobile-menu-item",
    style: {
      textAlign: centerMobileNavItems ? 'center' : 'left',
      display: 'block'
    },
    activeStyle: {
      textDecoration: 'bold'
    }
  }), internal ? /*#__PURE__*/_react["default"].createElement(_InternalLink["default"], {
    gatsbyLink: true,
    as: internalLinkComponent,
    to: slug,
    label: pageTitle,
    style: linkStyle,
    className: className
  }, linksAs === 'text' ? /*#__PURE__*/_react["default"].createElement("span", null, pageTitle) : /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, null, pageTitle)) : /*#__PURE__*/_react["default"].createElement(_OutboundLink["default"], {
    label: pageTitle,
    to: slug,
    style: linkStyle,
    className: className
  }, linksAs === 'text' ? /*#__PURE__*/_react["default"].createElement("span", null, pageTitle) : /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, null, pageTitle)));
};
exports["default"] = _default;